// Real ANGIELSKI GOTOWY™ sample pages (Tom 1), WebP hosted in Impultienda Recursos.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/488e14ea-b7e9-483a-92ef-f01d9b9d9e6b/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [{
  src: BASE + '1792380760271_ang-sample-lekcja-1-hello-41c44fb6.webp',
  label: 'Tom 1 · Lekcja klasy 1–3',
  title: 'Hello! Greetings – minuta po minucie',
  text: 'Cele, materiały, przebieg 45 minut i kluczowe zwroty po angielsku – cała lekcja gotowa do poprowadzenia.'
}, {
  src: BASE + '1792380765844_ang-sample-colour-by-number-fa0992ad.webp',
  label: 'Tom 1 · Karta pracy klasy 1–3',
  title: 'Colour by Number!',
  text: 'Kolorowanka z angielskimi nazwami kolorów i zadaniami na 3 poziomach: Wsparcie, Podstawa, Wyzwanie.'
}, {
  src: BASE + '1792380770765_ang-sample-map-of-sunnyville-21f95820.webp',
  label: 'Tom 1 · Karta pracy klasy 4–6',
  title: 'Map of Sunnyville',
  text: 'Wskazywanie drogi i przyimki miejsca – uczniowie wykonują polecenia i rysują trasę na mapie.'
}, {
  src: BASE + '1792380775963_ang-sample-at-the-shop-020aafcb.webp',
  label: 'Tom 1 · Karta pracy klasy 4–6',
  title: 'At the Shop',
  text: 'Dialog w sklepie do uzupełnienia, ceny i bank słów – w trzech poziomach trudności.'
}, {
  src: BASE + '1792380781067_ang-sample-classroom-english-93571153.webp',
  label: 'Tom 1 · Plakat',
  title: 'Classroom English – rutyny na lekcji',
  text: 'Powitanie, przejścia i zakończenie lekcji – plakat ze zwrotami do wydruku i powieszenia w klasie.'
}];
